import { render } from "./setting.vue?vue&type=template&id=56bc7d23&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=56bc7d23&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bc7d23"]])

export default __exports__